define.alias("ember-useragent/services/user-agent", "settings/services/user-agent");